import { SearchIcon } from "lucide-react";

export const PermissionInputHeader = ({
  search,
  searchText,
}: {
  search: string;
  searchText: (prop: string) => void;
}) => {
  return (
    <div className="flex w-full bg-gray-100  sticky top-0 text-sm">
      <div className="flex-1 py-1 pl-2 pr-3">
        <div className="relative">
          <SearchIcon className="absolute top-2.5 left-2.5" size={16} />
          <input
            type="search"
            placeholder="Search Name..."
            value={search}
            onChange={(e) => searchText(e.target.value)}
            className="py-2 pr-2 pl-8 rounded-sm border w-[300px]"
          />
        </div>
      </div>
      <div className="w-[100px]  py-3 px-3">View</div>
      <div className="w-[100px]  py-3 px-3">Create</div>
      <div className="w-[100px]  py-3 px-3">Update</div>
      <div className="w-[100px]  py-3 px-3">Delete</div>
      <div className="w-[160px]  py-3 px-3">View Own Data Only</div>
    </div>
  );
};
